import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { useBlogContext } from "../../fetchdata/BlogContext";
const NavBar = () => {
  // const { notification } = useBlogContext();

  const [TotalNoti, setTotalNoti] = useState(0);

  // useEffect(() => {
  //   setTotalNoti(notification.length);
  // }, [notification]);

  return (
    <>
      {/* Menubar */}
      <div className="menubar-area footer-fixed">
        <div className="toolbar-inner menubar-nav">
          <NavLink to="/" className="nav-link ">
            <i className="ri-home-3-line  fs-3"></i>
          </NavLink>
          <NavLink to="/my-location" className="nav-link notificationbox">
            <i className="ri-map-pin-2-fill fs-3"></i>
           
          </NavLink>

      

          <NavLink to="/account/all-order" className="nav-link ">
            <i className="ri-taxi-wifi-fill  fs-3"></i>
          </NavLink>

          <NavLink to="/account" className="nav-link  ">
            <i className="ri-user-3-line fs-3"></i>
          </NavLink>
        </div>
      </div>
      {/* Menubar */}
      {/* Nav Floting End */}
    </>
  );
};

export default NavBar;
